export const INACTIVE_USERS_MODULE_KEY = 'inactiveUsers';
export const INACTIVE_USERS_BASE_ROUTE = '/inactiveUsers';
export const INACTIVE_USERS_FILTER_KEY = 'inactiveUsers';
